export const Dispositif = ['CAPP', 'CPRO', 'PROA', 'AF', 'FPE'] as const

export type Dispositif = (typeof Dispositif)[number]
